import actionTypes from "../actionTypes";
import {IParcela, IZona} from "../../types";
import {LatLngTuple} from "leaflet";

const update = require('immutability-helper');


export const initialState = {
    menu: true as boolean,
    parcela: {} as IParcela,
    sectores: {} as Record<string, LatLngTuple[]>,
    products: {} as Record<string, Record<string, string[]>>,
    selected: [] as string[],
    product: '' as string,
    bounds: [[0, 0], [0, 0]] as LatLngTuple[],
    zonificacion: false as boolean,
    zonas: 3 as number,
    histograma: [] as Record<string, number>[],
    scale: {} as Record<number, (number | string)[]>,
    zonificaciones: [] as IZona[],
    loading_zonificador: false as boolean,
    zonificacion_selected: '' as string,
    zonas_scale: {} as Record<number, (number[] | string)[]>,
    props_zonificacion: false as boolean,
    init_rotated_layer: false as boolean,
    notas_campo: false as boolean,
    estaciones: false as boolean
};

export function reducer(state: typeof initialState=initialState, action: actionTypes) {
    switch (action.type) {
        case 'set-visualizador-parcela':
            return update(state, {parcela: {$set: action.parcela}});

        case 'set-visualizador-sectores':
            return update(state, {sectores: {$set: action.sectores}});

        case 'set-visualizador-products':
            return update(state, {products: {$set: action.products}});

        case 'set-visualizador-selected':
            return update(state, {selected: {$set: action.selected}});

        case 'set-visualizador-product':
            return update(state, {product: {$set: action.product}});

        case 'set-visualizador-bounds':
            return update(state, {bounds: {$set: action.bounds}});

        case 'set-visualizador-zonificacion':
            return update(state, {zonificacion: {$set: action.zonificacion}});

        case 'set-visualizador-menu':
            return update(state, {menu: {$set: action.menu}});

        case 'set-visualizador-zonas':
            return update(state, {zonas: {$set: action.zonas}});

        case 'set-visualizador-histograma':
            return update(state, {histograma: {$set: action.histograma}});

        case 'set-visualizador-scale':
            return update(state, {scale: {$set: action.scale}});

        case 'set-visualizador-zonificaciones':
            return update(state, {zonificaciones: {$set: action.zonificaciones}});

        case 'set-loading-zonificador':
            return update(state, {loading_zonificador: {$set: action.loading_zonificador}});

        case 'set-visualizador-zonificacion-selected':
            return update(state, {zonificacion_selected: {$set: action.zonificacion_selected}});

        case 'set-visualizador-zonas-scale':
            return update(state, {zonas_scale: {$set: action.zonas_scale}});

        case 'set-visualizador-props-zonificacion':
            return update(state, {props_zonificacion: {$set: action.props_zonificacion}});

        case 'init-rotated-layer':
            return update(state, {init_rotated_layer: {$set: action.init_rotated_layer}});

        case 'notas-campo':
            return update(state, {notas_campo: {$set: action.notas_campo}});

        case 'estaciones':
            return update(state, {estaciones: {$set: action.estaciones}});

        default:
            return state
    }
}